var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import maplibregl from 'maplibre-gl';
var PopupManager = /** @class */ (function () {
    function PopupManager(map) {
        this.currentPopup = null;
        this.map = map;
    }
    PopupManager.prototype.createPopupElement = function (title, location) {
        var _a, _b, _c;
        var div = document.createElement('div');
        var resourceUrl = (_a = window.rmSettings) === null || _a === void 0 ? void 0 : _a.resourceUrl;
        div.innerHTML = "\n            <h3 style=\"margin: 0 0 10px 0\">".concat(title, "</h3>\n            <p style=\"margin: 0 0 10px 0\">").concat(location, "</p>\n            <a href=\"").concat(resourceUrl, "?search=").concat(encodeURIComponent(title), "\">").concat(((_c = (_b = window.rmSettings) === null || _b === void 0 ? void 0 : _b.translations) === null || _c === void 0 ? void 0 : _c.viewResource) || 'View Program', "</a>\n        ");
        return div;
    };
    PopupManager.prototype.closeCurrentPopup = function () {
        if (this.currentPopup) {
            this.currentPopup.remove();
            this.currentPopup = null;
        }
    };
    PopupManager.prototype.createSinglePointPopup = function (coordinates, props) {
        if (!props.title)
            return;
        var element = this.createPopupElement(props.title, props.location || '');
        this.currentPopup = new maplibregl.Popup()
            .setLngLat(coordinates)
            .setDOMContent(element)
            .addTo(this.map);
    };
    PopupManager.prototype.createClusterPopup = function (coordinates, props) {
        var _a, _b, _c, _d, _e;
        var titles = props.titles.split('||').filter(Boolean);
        var urls = props.urls.split('||').filter(Boolean);
        var locations = props.locations.split('||').filter(Boolean);
        var community = locations[0] || 'this location';
        var resourceCount = titles.length;
        var popup = document.createElement('div');
        popup.className = 'cluster-popup';
        popup.innerHTML = "\n            <h3>".concat(((_b = (_a = window.rmSettings) === null || _a === void 0 ? void 0 : _a.translations) === null || _b === void 0 ? void 0 : _b.resourcesInLocation.replace('{count}', resourceCount.toString()).replace('{location}', community)) || "".concat(resourceCount, " Programs in ").concat(community), "</h3>\n            <a href=\"").concat((_c = window.rmSettings) === null || _c === void 0 ? void 0 : _c.resourceUrl, "?community=").concat(encodeURIComponent(community), "\" class=\"view-all\">").concat(((_e = (_d = window.rmSettings) === null || _d === void 0 ? void 0 : _d.translations) === null || _e === void 0 ? void 0 : _e.viewAllInLocation.replace('{location}', community)) || "View all programs in ".concat(community), "</a>\n            <div class=\"cluster-popup__list\">\n                ").concat(titles.map(function (title, index) {
            var _a, _b, _c;
            return "\n                    <div class=\"cluster-popup__item\">\n                        <h4>".concat(title, "</h4>\n                        <a href=\"").concat((_a = window.rmSettings) === null || _a === void 0 ? void 0 : _a.resourceUrl, "?search=").concat(encodeURIComponent(title), "\">").concat(((_c = (_b = window.rmSettings) === null || _b === void 0 ? void 0 : _b.translations) === null || _c === void 0 ? void 0 : _c.viewResource) || 'View Resource', "</a>\n                    </div>\n                ");
        }).join(''), "\n            </div>\n        ");
        this.currentPopup = new maplibregl.Popup()
            .setLngLat(coordinates)
            .setDOMContent(popup)
            .addTo(this.map);
    };
    return PopupManager;
}());
var MarkerManager = /** @class */ (function () {
    function MarkerManager(map, onError) {
        this.map = map;
        this.onError = onError;
        this.popupManager = new PopupManager(map);
    }
    MarkerManager.prototype.addMarkersToMap = function (locations) {
        var _this = this;
        var _a;
        try {
            ['cluster-count', 'clusters', 'cluster-centers', 'unclustered-point'].forEach(function (layer) {
                var _a;
                if ((_a = _this.map) === null || _a === void 0 ? void 0 : _a.getLayer(layer)) {
                    _this.map.removeLayer(layer);
                }
            });
            if (this.map.getSource('resources')) {
                this.map.removeSource('resources');
            }
            this.map.addSource('resources', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: locations.map(function (location) { return ({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [location.coordinates.lng, location.coordinates.lat]
                        },
                        properties: __assign(__assign({}, location.properties), { pulse: 0 })
                    }); })
                },
                cluster: true,
                clusterMaxZoom: 20,
                clusterRadius: 30,
                clusterProperties: {
                    titles: [
                        "concat",
                        ["concat", ["get", "title"], "||"],
                        ["accumulated"]
                    ],
                    urls: [
                        "concat",
                        ["concat", ["get", "resourceUrl"], "||"],
                        ["accumulated"]
                    ],
                    locations: [
                        "concat",
                        ["concat", ["get", "location"], "||"],
                        ["accumulated"]
                    ],
                    pulse: ['max', ['get', 'pulse']]
                }
            });
            this.map.addLayer({
                id: 'clusters',
                type: 'circle',
                source: 'resources',
                filter: ['has', 'point_count'],
                paint: {
                    'circle-color': '#FFB800',
                    'circle-radius': 10,
                    'circle-stroke-width': [
                        'step',
                        ['get', 'point_count'],
                        14,
                        10, 16,
                        20, 18
                    ],
                    'circle-stroke-color': '#FFB800',
                    'circle-stroke-opacity': [
                        'interpolate',
                        ['linear'],
                        ['get', 'pulse'],
                        0, 0.1,
                        1, 0.3
                    ]
                }
            });
            this.map.addLayer({
                id: 'cluster-count',
                type: 'symbol',
                source: 'resources',
                filter: ['has', 'point_count'],
                layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['Noto Sans Regular'],
                    'text-size': 12
                },
                paint: {
                    'text-color': '#ffffff'
                }
            });
            this.map.addLayer({
                id: 'unclustered-point',
                type: 'circle',
                source: 'resources',
                filter: ['!', ['has', 'point_count']],
                paint: {
                    'circle-color': '#FFB800',
                    'circle-radius': 8,
                    'circle-stroke-width': 12,
                    'circle-stroke-color': '#FFB800',
                    'circle-stroke-opacity': [
                        'interpolate',
                        ['linear'],
                        ['get', 'pulse'],
                        0, 0.1,
                        1, 0.3
                    ]
                }
            });
            this.setupPulseAnimation();
            this.setupEventHandlers();
        }
        catch (error) {
            (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this, error);
        }
    };
    MarkerManager.prototype.setupPulseAnimation = function () {
        var _this = this;
        var animate = function (timestamp) {
            var timeSin = timestamp % 10000 / 10000;
            _this.map.setPaintProperty('clusters', 'circle-stroke-opacity', [
                'interpolate',
                ['linear'],
                ['get', 'pulse'],
                0, 0.1 + timeSin * 0.2,
                1, 0.3
            ]);
            _this.map.setPaintProperty('unclustered-point', 'circle-stroke-opacity', [
                'interpolate',
                ['linear'],
                ['get', 'pulse'],
                0, 0.1 + timeSin * 0.2,
                1, 0.3
            ]);
            requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
    };
    MarkerManager.prototype.setupEventHandlers = function () {
        var _this = this;
        var handleFeatureClick = function (e, isCluster) {
            var _a;
            _this.popupManager.closeCurrentPopup();
            if (!((_a = e.features) === null || _a === void 0 ? void 0 : _a.length))
                return;
            var feature = e.features[0];
            var coordinates = feature.geometry.type === 'Point'
                ? feature.geometry.coordinates
                : [0, 0];
            var props = feature.properties;
            if (!props)
                return;
            if (isCluster && props.cluster) {
                _this.popupManager.createClusterPopup(coordinates, props);
            }
            else {
                _this.popupManager.createSinglePointPopup(coordinates, props);
            }
        };
        this.map.on('click', 'clusters', function (e) {
            handleFeatureClick(e, true);
        });
        this.map.on('click', 'unclustered-point', function (e) {
            handleFeatureClick(e, false);
        });
        this.map.on('mouseenter', 'clusters', function () {
            _this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'clusters', function () {
            _this.map.getCanvas().style.cursor = '';
        });
        this.map.on('mouseenter', 'unclustered-point', function () {
            _this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', 'unclustered-point', function () {
            _this.map.getCanvas().style.cursor = '';
        });
    };
    return MarkerManager;
}());
var ScrollZoomHandler = /** @class */ (function () {
    function ScrollZoomHandler(map, container, options) {
        this.hintTimeout = 0;
        this.map = map;
        if (!(options === null || options === void 0 ? void 0 : options.requireModKey))
            return;
        var isMac = /Mac|iPad|iPhone|iPod/.test(navigator.userAgent);
        var modifierKey = isMac ? '⌘' : 'Ctrl';
        this.hint = document.createElement('div');
        this.hint.className = 'map-zoom-hint';
        this.hint.innerHTML = "\n            <div class=\"map-zoom-hint__content\">\n                <svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"currentColor\">\n                    <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"/>\n                </svg>\n                <span>Hold ".concat(modifierKey, " to zoom map</span>\n            </div>\n        ");
        this.hint.style.display = 'none';
        container.appendChild(this.hint);
        container.addEventListener('wheel', this.handleZoom.bind(this, isMac), { passive: false });
        container.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    }
    ScrollZoomHandler.prototype.handleZoom = function (isMac, e) {
        var _this = this;
        var hasModifier = isMac ? e.metaKey : e.ctrlKey;
        if (hasModifier) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.map.scrollZoom.isEnabled()) {
                this.map.scrollZoom.enable();
            }
            this.hint.style.display = 'none';
        }
        else {
            if (this.map.scrollZoom.isEnabled()) {
                this.map.scrollZoom.disable();
            }
            this.hint.style.display = 'block';
            this.hint.classList.add('map-zoom-hint--visible');
            clearTimeout(this.hintTimeout);
            this.hintTimeout = window.setTimeout(function () {
                _this.hint.classList.remove('map-zoom-hint--visible');
                setTimeout(function () {
                    _this.hint.style.display = 'none';
                }, 300);
            }, 2000);
        }
    };
    ScrollZoomHandler.prototype.handleMouseLeave = function () {
        var _this = this;
        this.hint.classList.remove('map-zoom-hint--visible');
        setTimeout(function () {
            _this.hint.style.display = 'none';
        }, 300);
    };
    return ScrollZoomHandler;
}());
var MapLibreService = /** @class */ (function () {
    function MapLibreService() {
        this.map = null;
        this.markerManager = null;
        this.pendingLocations = null;
    }
    MapLibreService.prototype.initialize = function (container, options) {
        var _this = this;
        var _a;
        try {
            if (!options.style)
                throw new Error('Map style configuration is required');
            this.onError = options.onError;
            this.map = new maplibregl.Map({
                container: container,
                style: options.style,
                center: [options.center.lng, options.center.lat],
                zoom: options.zoom,
                maxBounds: options.maxBounds,
                scrollZoom: false,
                maxZoom: 16,
                minZoom: 3,
                localIdeographFontFamily: "'Noto Sans', sans-serif",
                dragRotate: false,
                pitchWithRotate: false,
                transformRequest: function (url) {
                    if (!url.includes('tiles.stadiamaps.com'))
                        return { url: url };
                    var matches = url.match(/\/(\d+)\/(\d+)\/(\d+)\.(pbf|json)/);
                    if (!matches)
                        return { url: url };
                    var _ = matches[0], z = matches[1], x = matches[2], y = matches[3], ext = matches[4];
                    return {
                        url: "".concat(window.location.origin, "/wp-json/resource-map/v1/tiles/").concat(z, "/").concat(x, "/").concat(y, ".").concat(ext)
                    };
                }
            });
            this.map.addControl(new maplibregl.NavigationControl({
                showCompass: false,
                visualizePitch: false
            }), 'top-right');
            if (this.map) {
                new ScrollZoomHandler(this.map, container, options.scrollZoom);
            }
            if (options.onInteraction) {
                ['mousedown', 'touchstart', 'dragstart', 'zoomstart'].forEach(function (event) {
                    var _a;
                    (_a = _this.map) === null || _a === void 0 ? void 0 : _a.once(event, options.onInteraction);
                });
            }
            this.map.on('error', function (e) {
                var _a, _b;
                var errorMessage = ((_a = e.error) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown map error';
                (_b = _this.onError) === null || _b === void 0 ? void 0 : _b.call(_this, new Error(errorMessage));
            });
            this.map.on('load', function () {
                if (_this.map) {
                    _this.markerManager = new MarkerManager(_this.map, _this.onError);
                    if (_this.pendingLocations) {
                        _this.markerManager.addMarkersToMap(_this.pendingLocations);
                        _this.pendingLocations = null;
                    }
                }
            });
        }
        catch (error) {
            (_a = this.onError) === null || _a === void 0 ? void 0 : _a.call(this, error);
            throw error;
        }
    };
    MapLibreService.prototype.addMarkers = function (locations) {
        if (!this.map)
            return;
        if (this.map.loaded() && this.markerManager) {
            this.markerManager.addMarkersToMap(locations);
        }
        else {
            this.pendingLocations = locations;
        }
    };
    MapLibreService.prototype.cleanup = function () {
        if (this.map) {
            this.map.remove();
            this.map = null;
            this.markerManager = null;
        }
    };
    return MapLibreService;
}());
export { MapLibreService };
